const trustItems = [
  { icon: 'ri-guide-line', text: 'Expert Spreadsheet Guides' },
  { icon: 'ri-scales-3-line', text: 'Detailed Comparisons' },
  { icon: 'ri-shield-check-line', text: 'Security Analysis' },
  { icon: 'ri-refresh-line', text: 'Updated Resources' },
];

export default function TrustBar() {
  return (
    <section className="relative z-10 -mt-10">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl py-6 px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {trustItems.map((item) => (
              <div key={item.text} className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-accent-600 text-base`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}